import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import FactoryIcon from "@mui/icons-material/Factory";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import MapIcon from "@mui/icons-material/Map";
import NotesIcon from "@mui/icons-material/Notes";
import PublicIcon from "@mui/icons-material/Public";
import { formatBroadSectorLabel } from "../../features/bre/companies/BRECompanyHelpers";
import { formatPhone } from "../../utils/Phone";

export function inquiryProfileConfig(inquiry = {}) {
  return [
    {
      title: "Company Information",
      rows: [
        {
          icon: <BusinessIcon />,
          label: "Company",
          value: inquiry.company_name,
        },
        {
          icon: <FactoryIcon />,
          label: "Sector",
          value: formatBroadSectorLabel(inquiry.sector),
          showIf: Boolean(inquiry.sector),
        },
        {
          icon: <FormatListBulletedIcon />,
          label: "NAICS Code",
          value: inquiry.naics_code,
          showIf: Boolean(inquiry.naics_code),
        },
        {
          icon: <FormatListBulletedIcon />,
          label: "NAICS Text",
          value: inquiry.naics_category,
          showIf: Boolean(inquiry.naics_category),
        },
        {
          icon: <PublicIcon />,
          label: "Source",
          value: inquiry.source,
          showIf: Boolean(inquiry.source),
        },
      ],
    },

    {
      title: "Contact Information",
      rows: [
        {
          icon: <PersonIcon />,
          label: "Contact",
          value: inquiry.contact_name,
          showIf: Boolean(inquiry.contact_name),
        },
        {
          icon: <EmailIcon />,
          label: "Email",
          value: inquiry.email,
          showIf: Boolean(inquiry.email),
        },
        {
          icon: <PhoneIcon />,
          label: "Phone",
          value: inquiry.phone ? formatPhone(inquiry.phone) : null,
          showIf: Boolean(inquiry.phone),
        },
      ],
    },

    {
      title: "Location",
      rows: [
        {
          icon: <PublicIcon />,
          label: "Country",
          value: inquiry.country,
          showIf: Boolean(inquiry.country),
        },
        {
          icon: <MapIcon />,
          label: "State / Province",
          value: inquiry.state_province,
          showIf: Boolean(inquiry.state_province),
        },
        {
          icon: <LocationCityIcon />,
          label: "City",
          value: inquiry.city,
          showIf: Boolean(inquiry.city),
        },
      ],
    },

    {
      title: "Status",
      rows: [
        {
          icon: <NotesIcon />,
          label: "Status",
          value: inquiry.status,
          showIf: Boolean(inquiry.status),
        },
      ],
    },
  ];
}
